/* @flow */
export const EXPANDED_SEARCH_GROUPS_EXPAND_GROUP =
    'EXPANDED_SEARCH_GROUP/EXPAND_GROUP';

type ExpandedSearchGroupsExpandGroupActionType =
    'EXPANDED_SEARCH_GROUP/EXPAND_GROUP';

type ExpandedSearchGroupsExpandGroupActionPayload = {
    index: number,
    hasModifiedMapViewport?: boolean
};

type ExpandedSearchGroupsExpandGroupAction = {
    type: ExpandedSearchGroupsExpandGroupActionType,
    payload: ExpandedSearchGroupsExpandGroupActionPayload
};

export type Action = ExpandedSearchGroupsExpandGroupAction;

const ACTION_CREATORS = {
    expandGroup({
        index,
        hasModifiedMapViewport
    }: ExpandedSearchGroupsExpandGroupActionPayload): ExpandedSearchGroupsExpandGroupAction {
        return {
            type: EXPANDED_SEARCH_GROUPS_EXPAND_GROUP,
            payload: {index, hasModifiedMapViewport}
        };
    }
};

export default {...ACTION_CREATORS};
